import React from 'react';
import { OverlayProps } from './Overlay.types';
import * as S from './Overlay.styles';
import { useAnimatedVisibility } from '@/hooks/useAnimatedVisibility';

export const Overlay = ({ isOpen, opacity, ...props }: OverlayProps) => {
  const { isVisible, onAnimationEnd } = useAnimatedVisibility(isOpen);

  if (!isVisible) return null;

  return (
    <S.OverlayBox
      $isOpen={isOpen}
      $opacity={opacity}
      onAnimationEnd={onAnimationEnd}
      {...props}
    />
  );
};
